import { queryOptions, useMutation, useQueryClient } from '@tanstack/react-query';
import { axiosGet, axiosPut } from '../utils/api';

const ADMIN_AI_SETTINGS_KEY = ['/admin/ai-settings'];

export const getAdminAiSettings = ({ accessToken } = {}) =>
  queryOptions({
    queryKey: ADMIN_AI_SETTINGS_KEY,
    queryFn: async () => {
      const res = await axiosGet('/admin/ai-settings', {}, accessToken);
      return res.data;
    },
  });

export const useUpdateAdminAiSettings = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data) => axiosPut('/admin/ai-settings', data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ADMIN_AI_SETTINGS_KEY });
    },
  });
};
